import axios from './axiosConfig';
import { IUser } from '../types/user';
import { environment } from '../config/environment';

export const userService = {
  createUser: async (
    username: string,
    password: string,
    isTfaEnabled: boolean,
    roles: string[],
    notificationsAllowedAccounts: string
  ): Promise<IUser> => {
    const reqBody = {
      username,
      password,
      isTfaEnabled,
      roles,
      notificationsAllowedAccounts,
    };

    const response = await axios.post<IUser>(
      `${environment.apiUrl}user`,
      reqBody
    );
    return response.data;
  },

  updateUser: async (
    username: string,
    password: string | undefined,
    isTfaEnabled: boolean,
    roles: string[],
    notificationsAllowedAccounts: string
  ): Promise<IUser> => {
    const reqBody = {
      username,
      password,
      isTfaEnabled,
      roles,
      notificationsAllowedAccounts,
    };

    const response = await axios.put<IUser>(
      `${environment.apiUrl}user`,
      reqBody
    );
    return response.data;
  },
};
